import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const formatDate = (date) => {
  const today = moment();
  if (today.diff(date, 'days') < 1) {
    return moment(date).fromNow();
  }

  if (today.year() === date.year()) {
    return date.format('MMM D h:mm a');
  }

  return date.format('MMM D, YYYY h:mm a');
};

const TimeDisplay = ({ date }) => {
  const m = moment(date);
  return (
    <span className="date-time-display" title={m.format('MMMM D, YYYY h:mm:ss a')}>
      {formatDate(m)}
    </span>
  );
};

TimeDisplay.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

export default TimeDisplay;



// WEBPACK FOOTER //
// ./src/components/TimeDisplay.js